import "./jsTips.scss"

function Js() {
    return (
        <div>Js</div>
    )
}

export default Js

